import { PasseriniAPI } from '@/services/apiService';

/**
 * Servicio para manejar archivos de storage protegidos
 */
class StorageService {
  /**
   * Obtiene un archivo de storage como Blob
   * El backend debe tener una ruta para servir estos archivos con autenticación
   */
  async getFile(path: string): Promise<Blob> {
    try {
      // Limpiar el path: remover / inicial si existe
      let cleanPath = path.startsWith('/') ? path.substring(1) : path;

      // Si el path incluye 'api/', removerlo porque PasseriniAPI ya lo agrega en baseURL
      if (cleanPath.startsWith('api/')) {
        cleanPath = cleanPath.substring(4);
      }

      const response = await PasseriniAPI.get(cleanPath, {
        responseType: 'blob',
      });

      return response.data;
    } catch (error) {
      console.error('Error al obtener archivo de storage:', error);
      throw error;
    }
  }

  /**
   * Crea una URL temporal (Object URL) para un archivo de storage
   * IMPORTANTE: Debes liberar la URL con URL.revokeObjectURL() cuando ya no la necesites
   */
  async createObjectUrl(path: string): Promise<string> {
    const blob = await this.getFile(path);
    return URL.createObjectURL(blob);
  }

  /**
   * Descarga un archivo de storage
   */
  async downloadFile(path: string, filename?: string): Promise<void> {
    try {
      const blob = await this.getFile(path);
      const url = URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      link.download = filename || path.split('/').pop() || 'download';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // Liberar la URL después de un breve delay
      setTimeout(() => URL.revokeObjectURL(url), 100);
    } catch (error) {
      console.error('Error al descargar archivo:', error);
      throw error;
    }
  }
}

export default new StorageService();
